export default {
    data() {
        return {
            toast: null,
            toastMessage: '',
            toastTitle: '',
            toastError: false
        };
    },

    mounted() {
        const toastEl = document.getElementById('saveToast');
        if (toastEl && window.ITToast) {
            this.toast = new window.ITToast(toastEl);
        } else {
            console.warn('Bootstrap Italia ITToast non disponibile');
        }
    },

    methods: {
        showSuccessToast(title = 'Successo', message = 'Operazione completata con successo') {
            this.toastError = false;
            this.toastTitle = title;
            this.toastMessage = message;
            this.toast?.show();
        },

        showErrorToast(title = 'Errore', message = 'Si è verificato un errore') {
            this.toastError = true;
            this.toastTitle = title;
            this.toastMessage = message;
            this.toast?.show();
        }
    }
};
